import Cookies from 'js-cookie';

import { triggerMobile } from '../utils/app-bridge';

type Tokens = {
  idToken: {
    jwtToken: string
  },
  accessToken: {
    jwtToken: string,
    payload?: {
      exp?: number
    }
  }
  refreshToken?: string
  uid?: string
};

const domains = process.env.REACT_APP_SSO_COOKIE_DOMAINS ? JSON.parse(process.env.REACT_APP_SSO_COOKIE_DOMAINS) : '';

export function setAuthCookies({ idToken, accessToken, refreshToken, uid }: Tokens, noTriggerMobile?: boolean): void {
  const customExpires = new Date();
  customExpires.setHours(customExpires.getHours() + 1);
  const expires = accessToken?.payload?.exp ? new Date(accessToken.payload.exp * 1000) : customExpires;
  const tempUid = Cookies.get('uid') ?? uid;
  const payload = {
    'action': 'login',
    'data': {
      'accessToken': accessToken.jwtToken,
      'idToken': idToken.jwtToken,
      'refreshToken': refreshToken,
    },
  };
  if (!noTriggerMobile) triggerMobile(payload);

  domains.forEach((domain: string) => {
    document.cookie = `_cogat=${accessToken.jwtToken};expires=${expires.toUTCString()};domain=${domain};path=/`;
    document.cookie = `_cogit=${idToken.jwtToken};expires=${expires.toUTCString()};domain=${domain};path=/`;
    if (tempUid) {
      document.cookie = `uid=${tempUid};expires=${expires.toUTCString()};domain=${domain};path=/`;
    }
  });
}

export function unsetAuthCookies(): void {
  domains.forEach((domain: string) => {
    document.cookie = `_cogat=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${domain};path=/`;
    document.cookie = `_cogit=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${domain};path=/`;
    document.cookie = `uid=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${domain};path=/`;
  });
}

export function checkAuthCookies(): boolean {
  const cogatCookie = Cookies.get('_cogat');
  const cogitCookie = Cookies.get('_cogit');

  return !(!cogatCookie && !cogitCookie);
}

export function checkFederatedRedirectUrl(): string | false {
  const federatedRedirectUrl = Cookies.get('federatedRedirectUrl');
  domains.forEach((domain: string) => {
    document.cookie = `federatedRedirectUrl=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${domain};path=/`;
  });
  return federatedRedirectUrl || false;
} 